import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { EditPatientAllergyRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchEditPatientAllergyByUserId } from '../api/editPatientAllergyByUserId.js';
import { rxKeys } from './keys.js';

export interface EditPatientAllergyVariables {
  userId: string;
  allergyId: string;
  data: EditPatientAllergyRequestT;
}

export function useEditPatientAllergyMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['rx', 'patient', 'allergies', 'edit'],
    mutationFn: async ({ userId, allergyId, data }: EditPatientAllergyVariables) => {
      return await fetchEditPatientAllergyByUserId(userId, allergyId, data);
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({ queryKey: rxKeys.patientAllergies(variables.userId) });
    },
  });
}
